import { useContext } from "react"
import { EmissaoCupomFiscalContext } from "./EmissaoCupomFiscalContext"

export function useEmissaoCupomFiscalContext() {
    return useContext(EmissaoCupomFiscalContext)
}
